import { render, staticRenderFns } from "./comFooter.vue?vue&type=template&id=4f6bd101&scoped=true"
import script from "./comFooter.vue?vue&type=script&lang=js"
export * from "./comFooter.vue?vue&type=script&lang=js"
import style0 from "./comFooter.vue?vue&type=style&index=0&id=4f6bd101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bd101",
  null
  
)

export default component.exports